import type {
  LegalPageLanguage,
  LegalPageResponse,
  LegalPageType,
} from "../types/legal-page";
import { apiFetch } from "./client";

export async function getLegalPage(type: LegalPageType): Promise<LegalPageResponse> {
  return apiFetch<LegalPageResponse>(`/api/v1/admin/legal-pages/${type}`);
}

export async function publishLegalPage(
  type: LegalPageType,
  translations: Record<LegalPageLanguage, string>,
): Promise<LegalPageResponse> {
  return apiFetch<LegalPageResponse>(`/api/v1/admin/legal-pages/${type}/publish`, {
    method: "PUT",
    body: JSON.stringify({ translations }),
  });
}
